import type { FolderSummary } from './api/types'

export function compareLibraryFolders(a: FolderSummary, b: FolderSummary): number {
  return (a.sort_order ?? Number.MAX_SAFE_INTEGER) - (b.sort_order ?? Number.MAX_SAFE_INTEGER) || a.name.localeCompare(b.name, 'zh-CN') || a.id.localeCompare(b.id)
}

export function folderLocation(id: string, name?: string): string {
  if (id === 'all') return '/library'
  const query = new URLSearchParams({ folder: id })
  if (name) query.set('folder_name', name)
  return `/library?${query.toString()}`
}
export function directSubfolders(rows: FolderSummary[], parentId: string): FolderSummary[] {
  return rows.filter(row => row.status === 'active' && row.parent_id === (parentId === 'all' ? null : parentId))
    .sort(compareLibraryFolders)
}
export function repositionSubfolder(rows: FolderSummary[], parentId: string, sourceId: string, targetId: string, after: boolean): FolderSummary[] {
  const siblings = directSubfolders(rows, parentId), source = siblings.find(folder => folder.id === sourceId)
  if (!source || sourceId === targetId || !siblings.some(folder => folder.id === targetId)) return siblings
  const ordered = siblings.filter(folder => folder.id !== sourceId)
  ordered.splice(ordered.findIndex(folder => folder.id === targetId) + Number(after), 0, source)
  return ordered
}
export function subfolderPage(rows: FolderSummary[], parentId: string, requestedPage: number) {
  const children = directSubfolders(rows,parentId), pageSize = 10
  const pageCount = Math.max(1,Math.ceil(children.length/pageSize))
  const page = Math.min(pageCount,Math.max(1,Math.trunc(requestedPage) || 1))
  return { items: children.slice((page-1)*pageSize,page*pageSize), total: children.length, page, pageCount }
}
export function folderAncestors(rows: FolderSummary[], id: string): FolderSummary[] {
  const map = new Map(rows.map(row => [row.id, row]))
  const path: FolderSummary[] = [], seen = new Set<string>()
  let node = map.get(id)
  while (node && !seen.has(node.id)) { seen.add(node.id); path.unshift(node); node = node.parent_id ? map.get(node.parent_id) : undefined }
  return path
}
